import { Subtyp2 } from "~app/common/components/map/symbols/kartgeometri.constants";
import { IKartgeometriBasdataResponse, Kartgeometri } from "./kartgeometri.model";

export class PopupDialogInputMatrix {

    readonly drivningspunkt = "Drivningspunkt";
    readonly vag = "Väg";
    readonly avlagg = "Avlägg";
    readonly overfart = "Överfart";
    readonly ovrigOverfart = "Övrig drivningspunkt";
    readonly drivningslinje = "Drivningslinje";
    readonly hansynYta = "Hänsyn yta";
    readonly anvisningYta = "Anvisning yta";
    readonly hansynPunkt = "Hänsyn punkt";
    readonly hansynLinje = "Hänsyn linje";
    readonly tradTradgrupp = "Träd/Trädgrupp";
    readonly kantzon = "Kantzon";
    readonly plockhuggning = "Plockhuggning";
    readonly kojplats = "Kojplats";
    readonly larmpunkt = "Larmpunkt";
    readonly drivningstext = "Drivningstext";
    readonly ovrigDrivningspunkt = "Övrig drivningspunkt";
    readonly avlaggOchLarmpunkt = "Avlägg & Larmpunkt";
    readonly allmanLinje = "Allmän linje";
    readonly allmanPunkt = "Allmän punkt";

    labelConstantSubtyp3: string;
    showSubtyp3Selector: boolean;
    showTillganglighetsklassSelector: boolean;
    showAnteckning: boolean;
    showLangd: boolean;
    showPlockhuggning: boolean;
    showKarttext: boolean;
    karttextLabel = "Drivningstext";
    showYta: boolean;
    limitSubtyp2: boolean;
    limitedSubtyp2: string[];

    constructor(private readonly kartgeometri: Kartgeometri, private readonly kartgeometriBasdata: IKartgeometriBasdataResponse) {
    }

    update() {
        this.reset();
        switch (this.kartgeometri.subtyp1) {
            case this.vag:
                this.showTillganglighetsklassSelector = true;
                this.showAnteckning = true;
                this.showLangd = true;
                break;
            case this.drivningspunkt:

                switch (this.kartgeometri.subtyp2) {
                    case this.avlagg:
                    case this.avlaggOchLarmpunkt:
                        this.showTillganglighetsklassSelector = true;
                        this.showAnteckning = true;
                        break;
                    case this.overfart:
                        this.labelConstantSubtyp3 = "KARTGEOMETRI_POPUP_OVERFART_TYP";
                        this.showSubtyp3Selector = true;
                        this.showAnteckning = true;
                        break;
                    case this.ovrigOverfart:
                        this.labelConstantSubtyp3 = "KARTGEOMETRI_POPUP_OVRIG_DRIVNINGSPUNKT_TYP";
                        this.showSubtyp3Selector = true;
                        this.showAnteckning = true;
                        break;
                        // eslint-disable-next-line sonarjs/no-fallthrough
                    case this.drivningstext:
                        this.showKarttext = true;
                    case this.kojplats:
                    case this.larmpunkt:
                        this.showAnteckning = true;
                        break;
                }
                break;
            case this.drivningslinje:
                this.showLangd = true;
                this.showAnteckning = true;
                break;
            case this.hansynYta:

                switch (this.kartgeometri.subtyp2) {
                    case this.kantzon:
                    case this.tradTradgrupp:
                        this.showPlockhuggning = true;
                        break;
                }

                this.labelConstantSubtyp3 = "KARTGEOMETRI_POPUP_HANSYN_YTA_TYP";
                this.showSubtyp3Selector = true;
                this.showAnteckning = true;
                this.showYta = true;
                this.kartgeometri.subtyp3 = this.getTypAvTypStandardvalue(); // Flytta! logik
                break;
            case this.anvisningYta:
                this.showAnteckning = true;
                this.showYta = true;
                this.showSubtyp3Selector = false;
                break;
            case this.hansynPunkt:

                switch (this.kartgeometri.subtyp2) {
                    case this.kantzon:
                    case this.tradTradgrupp:
                        this.showPlockhuggning = true;
                        break;
                }

                this.labelConstantSubtyp3 = "KARTGEOMETRI_POPUP_HANSYN_PUNKT_TYP";
                this.showSubtyp3Selector = true;
                this.showAnteckning = true;
                this.kartgeometri.subtyp3 = this.getTypAvTypStandardvalue();  // Flytta! logik
                break;
            case this.hansynLinje:
                this.labelConstantSubtyp3 = "KARTGEOMETRI_POPUP_HANSYN_LINJE_TYP";
                this.showSubtyp3Selector = true;
                this.showLangd = true;
                this.showAnteckning = true;
                this.kartgeometri.subtyp3 = this.getTypAvTypStandardvalue();  // Flytta! logik
                break;
            case this.allmanPunkt:
                this.showSubtyp3Selector = false;
                this.showLangd = false;
                this.showAnteckning = true;
                this.showKarttext = true;
                this.karttextLabel = "Karttext";
                this.limitSubtyp2 = true;
                this.limitedSubtyp2 = Subtyp2.AllmanPunktSubtyp2Lista;
                break;
            case this.allmanLinje:
                this.showSubtyp3Selector = false;
                this.showLangd = false;
                this.showAnteckning = true;
                this.showKarttext = false;
                this.limitSubtyp2 = true;
                this.limitedSubtyp2 = Subtyp2.AllmanLinjeSubtyp2Lista;
                break;
        }
    }

    private reset() {
        this.labelConstantSubtyp3 = "";
        this.showSubtyp3Selector = false;
        this.showTillganglighetsklassSelector = false;
        this.showAnteckning = false;
        this.showLangd = false;
        this.showPlockhuggning = false;
        this.showKarttext = false;
        this.limitSubtyp2 = false;
        this.limitedSubtyp2 = [];
    }

    private getTypAvTypStandardvalue(): string {

        this.clearInvalidSubtypes();
        if (this.kartgeometri.subtyp3 === undefined && this.kartgeometri.subtyp2) {
            return this.kartgeometriBasdata.subtyper3
                .filter(x => x.namn === this.kartgeometri.subtyp2)[0].standardvarde;
        } else if (this.kartgeometri.subtyp3) {
            return this.kartgeometri.subtyp3;
        } else {
            return undefined;
        }
    }

    private clearInvalidSubtypes() {
        const validValues = this.kartgeometriBasdata.subtyper3.find(v => v.namn === this.kartgeometri.subtyp2)?.typer;
        if (!validValues || validValues.indexOf(this.kartgeometri.subtyp3) === -1) {
            this.kartgeometri.subtyp3 = undefined;
        }
    }

}
